var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner'),_c('section',{staticClass:"main"},[_c('Slider'),_c('SecondSlider'),_c('List')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }